import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginRequiredComponent } from '@app/common/components/dialogs/login-required/login-required.component';

@Injectable({
  providedIn: 'root',
})
export class LoginRequiredInterceptor implements HttpInterceptor {
  constructor(private readonly dialog: MatDialog) {}

  handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (HttpStatusCode.Unauthorized !== err.status) {
      return throwError(() => err);
    }
    return this.dialog.open(LoginRequiredComponent, { disableClose: true }).afterClosed();
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const authReq = req.clone();
    return next.handle(authReq).pipe(catchError((x) => this.handleAuthError(x)));
  }
}
